var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$store.getters.noScroll? 'open': '',attrs:{"id":"app"}},[_c('page-loading'),(_vm.hasAuth)?_c('div',{ref:"app",staticClass:"app-wrapper"},[_c('nav-bar'),_c('router-view'),_c('footer-component'),_c('custom-popup')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }